<template>
    <article class="restaurant-card">
        <nuxt-link
            class="inner"
            :to="to"
        >
            <div class="image-holder">
                <lazy-background
                    :src="image.src"
                    :alt="image.alt"
                />
            </div>
            <div class="text-content">
                <h3 class="title" v-test:title>{{ title }}</h3>
                <address class="address" v-test:address>{{ address }}</address>
            </div>
        </nuxt-link>
    </article>
</template>

<script>
    export default {
        name: 'restaurant-card',

        props: {
            to: {
                type: String,
                required: true,
            },

            image: {
                type: Object,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    $desktop-breakpoint: md;

    .inner {
        text-align: center;
        text-decoration: none;
        display: block;
        transition: outline-color 0.3s;

        &:hover,
        &:focus-visible,
        &:active {
            .image-holder {
                filter: brightness(0.95);
            }

            .title {
                text-decoration: underline;
            }

            .address {
                color: primary-palette(2);
            }
        }
    }

    .image-holder {
        transition: filter 0.3s;
        margin-bottom: 17px;
        background-color: secondary-palette(7);
        border-radius: 10px;
        overflow: hidden;
    }

    .lazy-background {
        padding-bottom: 100%;
    }

    .text-content {
        padding-left: 10px;
        padding-right: 10px;
    }

    .title {
        font-size: rem(16px);
        line-height: rem(20px);
        color: primary-palette(2);
        margin-bottom: 0;
    }

    .address {
        font-size: rem(14px);
        line-height: rem(18px);
        color: secondary-palette(5);
    }
</style>
